/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-undef */
// import "@google/model-viewer";
import React, { useEffect, useState } from "react";
import { useRecoilState, useRecoilValue } from "recoil";
import {
  addToProjectAtom,
  addToProjectImageAtom,
  loaderAtom,
  modelAtom,
  selectedAlphaAtom,
  selectedFabricAtom,
  vintageAtom,
} from "../../state";
import { GET_URL } from "../../constans";
import { fabricCompanyId, Handle_Global_Url } from "../../lib/constant";
import AntdSpin from "../Loader/AntdSpin";
import { v4 as uuidv4 } from 'uuid';
import { Storage } from 'aws-amplify';
import { SetS3Config } from "../../aws_exports";
import { base64ToBlob } from "../../utils/utils";
import { toast } from "react-toastify";
import { Spin } from "antd";

const textures = {};

const GoogleModelViewer = () => {
  const modelViewer = document.querySelector("#model-viewer");
  const paint = useRecoilValue(vintageAtom);
  const alphaSelect = useRecoilValue(selectedAlphaAtom)
  const selectedFabric = useRecoilValue(selectedFabricAtom);
  const [modelAtomValue, setModelAtomValue] = useRecoilState(modelAtom);
  const [addToProject, setAddToProject] = useRecoilState(addToProjectAtom);
  const [addToProjectImage, setAddToProjectImage] = useRecoilState(addToProjectImageAtom);
  const [loader, setLoader] = useRecoilState(loaderAtom)
  const getCheckSupport = localStorage.getItem('checkSupport')
  const [projectSaveLoading, setProjectSaveLoading] = useState(false);

  useEffect(() => {
    const intervalId = setInterval(() => {
      if (document.getElementsByClassName('side-box active me-3 position-relative')?.[0]) {
        document.getElementsByClassName('side-box active me-3 position-relative')?.[0].click()
      }
    }, 200);
    // Cancel the interval after 5 seconds (5000 milliseconds)
    setTimeout(() => {
      clearInterval(intervalId);
    }, 200);
  }, [])

  const createAndApplyTexture = async (channel, modelPartName, fabricImg, checkParams) => {
    const base64Image = fabricImg?.search('data:image/png;base64') !== -1 ? true : false
    let imageConvert = fabricImg
    if (getCheckSupport === 'true' && window.webpSupport && !base64Image) {
      imageConvert = fabricImg?.replaceAll('.jpeg', '.webp')
    }
    try {
      if (modelViewer?.model) {
        let texture = null;
        if (textures[fabricImg]) {
          texture = textures[fabricImg];
        } else {
          texture = await modelViewer.createTexture(base64Image ? fabricImg : checkParams ? fabricImg : GET_URL(imageConvert));
          textures[fabricImg] = texture;
        }

        const model = modelViewer.model;
        const parts = model[Object.getOwnPropertySymbols(model)[1]];

        const meterialIndexies = [];
        const partWiseIndex = {};

        parts.forEach((part) => {
          const index = part.initialMaterialIdx;
          partWiseIndex[index] = part.name;
          if (modelPartName === part.name) {
            // if (modelPartName === part.name || part.name === "Wood") {
            meterialIndexies.push(index);
          }
          if (part.name === 'Acrylic') {
            const material = modelViewer.model.materials[index];
            material.pbrMetallicRoughness.setBaseColorFactor('#ffffff');
          }
        });

        meterialIndexies.forEach(index => {
          const material = modelViewer.model.materials[index];
          const pbrMR = material.pbrMetallicRoughness;

          if (channel.includes("base") || channel.includes("metallic")) {
            pbrMR[channel].setTexture(texture);
          } else {
            material[channel].setTexture(texture);
          }
        });
      }
    } catch (err) {
      console.error(err);
    }
  };

  const updateMaterial = async () => {
    // if (modelViewer) {
    //   modelViewer.exposure = inputValue?.Exposure
    // }
    let keys, material;
    const keyName = Object.keys(paint.partWiseFabric)
    keys = !keyName?.length ? alphaSelect?.name ? paint.currentPart : keyName : keyName;
    material = paint;

    if (keys.length === 0) {
      return;
    }
    for (const key of keys) {
      if (!material?.partWiseFabric[key]?.diffuse) {
        return;
      }
      if (material?.partWiseFabric[key]?.diffuse || material?.partWiseFabric[key]?.alphaDiffuse) {
        await createAndApplyTexture(
          "baseColorTexture",
          key,
          material.partWiseFabric[key].diffuse
        );
      }
      if (material.partWiseFabric[key]) {
        await createAndApplyTexture(
          "metallicRoughnessTexture",
          key,
          material.partWiseFabric[key].metallicRoughness
        );

        await createAndApplyTexture(
          "normalTexture",
          key,
          material.partWiseFabric[key].normal,
          false
        );
      }
    }
  };

  useEffect(() => {
    if (modelViewer) {
      modelViewer.exposure = alphaSelect?.exposure
      updateMaterial();
      setTimeout(async () => {
        setLoader(false)
        // setModelAtomValue({
        //   ...modelAtomValue,
        //   loading: 100,
        // });
      }, 3000)
    }
  }, [paint, modelAtomValue.src, alphaSelect]);

  // useEffect(() => {
  //   if (modelViewer) {
  //     modelViewer.exposure = inputValue?.Exposure
  //   }
  // }, [inputValue]);

  // if (modelViewer) {
  //   modelViewer.addEventListener("load", (data) => {
  //     const childrenName = document.getElementsByClassName('active-category')?.[0]?.children[0]?.alt
  //     if (paint?.name?.replaceAll('_', ' ') === childrenName) {
  //       // updateMaterial();
  //     }
  //   });
  // }

  document.querySelector("#model-viewer")?.addEventListener("progress", (event) => {
    if (event.detail.totalProgress === 1) {
      setModelAtomValue({
        ...modelAtomValue,
        loading: 100,
      })
      setLoader(false)
    }
  })

  const addToProjectHandler = async () => {
    // change here
    setProjectSaveLoading(true)
    document.querySelector('model-viewer').fieldOfView = 10
    document.querySelector("#model-viewer").cameraOrbit = '0deg 75deg 90%'
    setTimeout(async () => {
      const parts = [
        {
          name: selectedFabric?.name,
          img: GET_URL(selectedFabric?.finish),
          quantity: 1,
          type: "paint",
          selected: selectedFabric,
          code: selectedFabric?.code
        },
        {
          name: alphaSelect?.name,
          img: alphaSelect?.image,
          quantity: 1,
          type: "alpha",
          code: alphaSelect?.code
        },
        {
          name: paint?.handle,
          img: `${Handle_Global_Url}${paint?.image}`,
          quantity: 1,
          type: "handle",
          code: paint?.code
        },
      ]
      const checkSameName = addToProject?.filter(data => data?.name === paint?.name.replaceAll('_', ' '))
      let checkData
      if (checkSameName?.length > 0) {
        checkData = addToProject?.findIndex(data => JSON.stringify(data?.parts) === JSON.stringify(parts))
      } else {
        checkData = -1
      }
      if (checkData === -1) {
        const dataNew = document.querySelector("#model-viewer").toDataURL('image/png')
        const frontImgBlob = base64ToBlob(dataNew, 'image/png');
        const cehckIndex = addToProject?.length ? Number(addToProject?.[0]?.seriesName?.slice(1)) : 0
        const reduceImage = ''
        const reduceBlob = base64ToBlob(reduceImage, 'image/png');
        let ItemAlphaImg;
        let ItemFrontImg;
        SetS3Config();
        await Storage.put(`${fabricCompanyId}/images/${uuidv4()}.png`, frontImgBlob, {
          contentType: '.png',
        }).then(async (result) => {
          ItemFrontImg = result?.key;
        }).catch(err => {
          toast.error(err.message);
        });
        await Storage.put(`${fabricCompanyId}/images/${uuidv4()}.png`, reduceBlob, {
          contentType: '.png',
        }).then(async (result) => {
          ItemAlphaImg = result?.key;
        }).catch(err => {
          toast.error(err.message);
        });
        const addData = {
          name: paint?.name.replaceAll('_', ' '),
          type: 'vintage',
          parts,
          quantity: 1,
          base64Image: ItemFrontImg,
          alphaImage: ItemAlphaImg,
          modelAtomValue,
          fabric: paint,
          alphaSelect,
          orderStatus: "pending",
          paymentStatus: "pending",
          createdAt: new Date(),
          seriesName: cehckIndex + 1 > 9 ? `S${cehckIndex + 1}` : `S0${cehckIndex + 1}`
        }
        setAddToProjectImage([dataNew, ...addToProjectImage])
        setAddToProject([addData, ...addToProject])
      } else {
        const updatedData = addToProject?.map((data, index) => {
          if (index === checkData) {
            const partUpdate = data?.parts?.map(partdata => {
              return { ...partdata, quantity: partdata?.quantity + 1 }
            })
            return { ...data, quantity: data.quantity + 1, parts: partUpdate }
          } else {
            return data
          }
        })
        setAddToProject(updatedData)
      }
      setProjectSaveLoading(false)
      document.querySelector("#model-viewer").cameraOrbit = '0deg 75deg 105%'
    }, 1000)
  }

  if (modelAtomValue.src) {
    return (
      <>
        <div className="relative">
          {/* {modelAtomValue.loading === 0 && <AntdSpin />} */}
          {loader && <AntdSpin />}
          <div
            id="card"
            className={`transition-opacity duration-1000 ease-in-out ${loader ? 'opacity-0' : 'opacity-100'}`}>
            <model-viewer
              tone-mapping="commerce"
              src={modelAtomValue.src}
              camera-controls
              disable-pan
              ar
              // camera-orbit="0deg 90deg 3m"
              className="h-[57vh] w-full"
              id="model-viewer"
            ></model-viewer>
          </div>
        </div>
        <button
          className="btn bg-black text-white btn-outline-primary mb-3 max-w-12 w-full mx-auto"
          onClick={() => addToProjectHandler()}
          disabled={projectSaveLoading}
        >
          Add To Selection {projectSaveLoading && <Spin className="project-save-submit-loader" />}
        </button>
      </>
    );
  } else {
    return <></>
  }
};

export default GoogleModelViewer;
